// src/components/Footer/index.jsx
import React from 'react';
import { Layout } from 'antd';
import { VerticalAlignTopOutlined, MailOutlined, GithubOutlined, WechatOutlined, HomeOutlined } from '@ant-design/icons';
import './index.css';

const { Footer } = Layout;

const BlogFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Footer className="blog-footer">
      {/* 回到顶部按钮 */}
      <div className="back-to-top" onClick={scrollToTop}>
        <VerticalAlignTopOutlined />
      </div>

      {/* 波浪背景 */}
      <div className="wave-bg"></div>

      <div className="footer-content">
        <div className="footer-section">
          <h3>如果文物会说话</h3>
          <p>以文物之眼，观历史之变</p>
          <p>让沉默的文物发声，让历史的记忆传承</p>
          <p>每一件文物都是时空的见证者</p>
        </div>
        
        <div className="footer-section">
          <h4>探索发现</h4>
          <div className="contact-item">
            <i>🏺</i>
            <span>青铜器 · 瓷器 · 玉器</span>
          </div>
          <div className="contact-item">
            <i>📜</i>
            <span>书画 · 古籍 · 壁画</span>
          </div>
          <div className="contact-item">
            <i>⚱️</i>
            <span>金银器 · 陶器 · 雕塑</span>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>联系我们</h4>
          <div className="contact-item">
            <MailOutlined />
            <span>cultural@heritage.com</span>
          </div>
          <div className="contact-item">
            <HomeOutlined />
            <span>文物研究院</span>
          </div>
        </div>
      </div>

      {/* 社交链接 */}
      <div className="social-links">
        <a href="https://github.com" className="social-link" target="_blank" rel="noopener noreferrer">
          <GithubOutlined />
        </a>
        <a href="mailto:cultural@heritage.com" className="social-link">
          <MailOutlined />
        </a>
        <a href="#wechat" className="social-link">
          <WechatOutlined />
        </a>
      </div>

      <div className="copyright">
        <p>
          © 2025 如果文物会说话 版权所有 
          <span className="divider">|</span>
          传承文明，守护记忆
          <span className="divider">|</span>
          <a href="#privacy">隐私政策</a>
          <span className="divider">·</span>
          <a href="#terms">使用条款</a>
        </p>
        <p>本站内容基于文物研究，仅供学习交流使用</p>
      </div>
    </Footer>
  );
};

export default BlogFooter;